module.exports = __webpack_public_path__ + "img/experiences5.60dd5084.jpg";